import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {EndpointInterceptor} from './endpoint.interceptor';
import {TokenRenovationInterceptor} from './token-renovation.interceptor';

export const httpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: TokenRenovationInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: EndpointInterceptor, multi: true}
];
